module.exports = __webpack_public_path__ + "static/media/gallery-wrap1.dc68eccb.jpeg";